import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

import { geoHeader } from "./geo";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const g = geoHeader();
  if (g) config.headers["X-Geo"] = g;
  return config;
});

// Transparently refresh the 15-min access token for active users. A single shared
// refresh promise avoids stampedes when many requests 401 at once.
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    const skip = url.includes("/auth/login") || url.includes("/auth/refresh") || url.includes("/auth/me");
    if (status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        refreshing = null;
        if (data?.access_token) localStorage.setItem("token", data.access_token);
        return api(original);
      } catch (e) {
        refreshing = null;
        localStorage.removeItem("token");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
